// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"b8085954","848":"b7b8f0ff","927":"e39abad7"}[chunkId] + ".chunk.css";
};